import { SupportProductModel } from 'models/SupportProductModel';
import { BaseZendeskFormAction, BaseZendeskAction } from './types';

export const getProducts = (
  product: SupportProductModel,
  selectedProducts: SupportProductModel[]
): SupportProductModel[] => {
  const productAlreadySelected = selectedProducts.some(sp => sp.productId === product.productId);

  if (productAlreadySelected) {
    const updatedProducts = selectedProducts.map(sp => {
      const isTargetProduct = sp.productId === product.productId;
      if (!isTargetProduct) {
        return sp;
      }
      return { ...sp, quantity: product.quantity };
    });

    return updatedProducts.filter(p => p.quantity > 0); // Remove those with quantity 0
  }

  const currentProduct = {
    productId: product.productId,
    productName: product.productName,
    productRecievedDate: product.productRecievedDate,
    quantity: product.quantity,
    unit: product.unit
  };

  return [...selectedProducts, currentProduct];
};

export const productChanged = (
  product: SupportProductModel,
  dispatch: (action: BaseZendeskFormAction) => void
) => {
  dispatch({ type: 'productChanged', value: product });
  dispatch({ type: 'productsError', value: '' });
};

export const subjectChanged = (
  subject: number,
  dispatch: (action: BaseZendeskAction) => void,
  withReason?: boolean
) => {
  dispatch({ type: 'subject', value: subject });
  dispatch({ type: 'subjectError', value: '' });
  if (withReason) {
    dispatch({ type: 'showReason', value: subject });
    dispatch({ type: 'reason', value: undefined });
  }
};

export const reasonChanged = (reason: number, dispatch: (action: BaseZendeskAction) => void) => {
  dispatch({ type: 'reason', value: reason });
  dispatch({ type: 'reasonError', value: '' });
};
